module.exports = __webpack_public_path__ + "img/vue1-doublure_lavande.c96183bd.png";